import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { H1, Typography, Button as BaseButton, Checkbox, Card as BaseCard } from '../components';
import { colors } from '../utils';
import { signTOUAcceptance as signTOUAcceptanceAction } from '../lib/redux/actions/me';
import { redirectToFirstPage } from '../lib/redux/actions/app';

const ButtonsWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
`;

const Button = styled(BaseButton)``;

const Title = styled(H1)`
  color: ${colors.g05};
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 40px;
`;

const Text = styled(Typography)`
  color: ${colors.g05};
  text-align: center;
  margin-bottom: 24px;
  text-align: left;
`;

const Wrapper = styled(BaseCard)`
  width: 581px;
  margin-top: 40px;
`;

const Link = styled.a`
  color: ${colors.b01};
  &:visited {
    color: ${colors.b01} !important;
  }
`;

export function VendorPrivacyTerms({ history, signTOUAcceptance }) {
  const [termsAgreed, setTermsAgreed] = useState(false);
  const [isSigning, setIsSigning] = useState(false);

  const onContinueClick = async () => {
    setIsSigning(true);

    try {
      await signTOUAcceptance();
      await redirectToFirstPage(history);
    } catch (err) {
      setIsSigning(false);
    }
  };

  return (
    <Wrapper>
      <Title>Your privacy is important to us</Title>
      <Text>
        At DefinedCrowd, our goal is to be as open and transparent as possible with our users about
        the personal data we collect, how it is used, and with whom it is shared.
      </Text>
      <Text>
        We have made changes to our Terms of Use and Privacy Policy to reflect the increased
        transparency requirements of the EU General Data Protection Regulation (known as the
        ‘GDPR’). Please review and accept our{' '}
        <Link target="_blank" href="https://www.neevo.ai/legal/">
          Terms of Use
        </Link>{' '}
        and{' '}
        <Link target="_blank" href="https://www.neevo.ai/privacy-policy/">
          Privacy Policy
        </Link>
        .
      </Text>
      <Text>
        We know that people who use our products place their trust in us and we will continue
        working to earn it. Feel free to email us your feedback at{' '}
        <Link href="mailto:neevo@neevo.ai">neevo@neevo.ai</Link>.
      </Text>

      <Checkbox
        data-test="agree-terms-checkbox"
        style={{ margin: 0 }}
        onToggle={() => setTermsAgreed(!termsAgreed)}
        checked={termsAgreed}
        label="I agree  to DefinedCrowd’s Terms of Use and Privacy Policy."
      />

      <ButtonsWrapper>
        <Button
          data-test="continue-button"
          disabled={!termsAgreed || isSigning}
          onClick={onContinueClick}
        >
          Continue
        </Button>
      </ButtonsWrapper>
    </Wrapper>
  );
}

VendorPrivacyTerms.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  signTOUAcceptance: PropTypes.func.isRequired
};

export default connect(
  null,
  {
    signTOUAcceptance: signTOUAcceptanceAction
  }
)(withRouter(VendorPrivacyTerms));
